import { BLOCKED_ITEM_FORM_CONDITIONS } from '@exam-center/blocked-user-management';
import { z } from 'zod';

export const BlockedRecordRevocationSchema = z.object({
  blockedUntil: z.date({ message: 'กรุณาระบุวันที่สิ้นสุดระงับสิทธิ์' }),
  additionalCourses: z.array(z.object({ value: z.string(), label: z.string() })),
  fileAttachments: z
    .array(
      z
        .instanceof(File, {
          message: 'กรุณาแนบไฟล์อัปโหลด',
        })
        .refine((file) => {
          return BLOCKED_ITEM_FORM_CONDITIONS.ALLOW_FILE_EXTENSIONS.includes(file.type);
        }, 'รูปแบบไฟล์ไม่ถูกต้อง กรุณาอัปโหลดไฟล์ .jpg หรือ .jpeg หรือ .png หรือ .pdf เท่านั้น'),
    )
    .max(BLOCKED_ITEM_FORM_CONDITIONS.MAX_FILE_ATTACHMENTS, {
      message: `ไม่สามารถอัปโหลดได้เกิน ${BLOCKED_ITEM_FORM_CONDITIONS.MAX_FILE_ATTACHMENTS} ไฟล์`,
    })
    .refine(
      (files) => {
        return (
          !files.length ||
          files.reduce((acc, file) => acc + file.size, 0) <=
            BLOCKED_ITEM_FORM_CONDITIONS.MAX_TOTAL_ATTACH_FILE_SIZE_IN_BYTES
        );
      },
      {
        message: `ขนาดไฟล์รวมกันต้องไม่เกิน ${BLOCKED_ITEM_FORM_CONDITIONS.MAX_TOTAL_ATTACH_FILE_SIZE_IN_MB} MB`,
      },
    )
    .refine(
      (files) => {
        return files.every((file) =>
          BLOCKED_ITEM_FORM_CONDITIONS.ALLOW_FILE_EXTENSIONS.includes(file.type),
        );
      },
      {
        message: 'รูปแบบไฟล์ไม่ถูกต้อง กรุณาอัปโหลดไฟล์ .jpg หรือ .jpeg หรือ .pdf เท่านั้น',
      },
    )
    .optional(),
  reason: z
    .string()
    .trim()
    .max(
      BLOCKED_ITEM_FORM_CONDITIONS.MAX_REASON_LENGTH,
      `ความยาวต้องไม่เกิน ${BLOCKED_ITEM_FORM_CONDITIONS.MAX_REASON_LENGTH} ตัวอักษร`,
    )
    .optional(),
});

export type BlockedRecordRevocationSchemaType = z.infer<typeof BlockedRecordRevocationSchema>;
